<!-- 移民项目 -->
<template>
  <div class="home">
    <div class="content">
      <h1 class="title">留学咨询</h1>
      <div
        class="box"
        v-for="(item, index) in 6"
        :key="index"
        @click="getImmigrationDetail()"
      >
        <div class="img">
          <img src="@/assets/BuyAbilityImg1.png" alt="" />
        </div>
        <div class="neirong">
          <h1>这是新闻标题这是新闻标题</h1>
          <h2>
            盐焗蛋收到了，发货和物流还是挺快的，包装外观完好无损，蛋都完好，和描述的一致。第一次参加拼团，比较划算，是一次满意的购物。盐焗蛋也已尝过，味道不错挺好吃的，咸淡适宜跟卤蛋还是有区别的，放在拌面或凉面里很不错的。现在足不出户就能买到各种东西盐焗蛋收到了，发货和物流还是挺快的，包装外观完好无损，蛋都完好，和描述的一致。第一次参加拼团，比较划算，是一次满意的购物。盐焗蛋也已尝过，味道不错挺好吃的，咸淡适宜跟卤蛋还是有区别的，放在拌面或凉面里很不错的。现在足不出户就能买到各第一次参加拼团，比较划算，是一次满意的购物。盐焗蛋也已尝过，味道不错挺好吃的，咸淡适宜跟卤蛋还是有区别的，放在拌面或凉面里很不错的。现在足不出户就能买到各种东西盐焗蛋收到了，发货和物流还是挺快的，包装外观完好无损，蛋都完好，和描述的一致。第一次参加拼团，比较划算，是一次满意的购物。盐焗蛋也已尝过，味道不错挺好吃的，咸淡适宜跟卤蛋还是有区别的，放在拌面或凉面里很不错的。现在足不出户就能买到各种东西第一次参加拼团，比较划算，是一次满意的购物。盐焗蛋也已尝过，味道不错挺好吃的，咸淡适宜跟卤蛋还是有区别的，放在拌面或凉面里很不错的。现在足不出户就能买到各种东西盐焗蛋收到了，发货和物流还是挺快的，包装外观完好无损，蛋都完好，和描述的一致。第一次参加拼团，比较划算，是一次满意的购物。盐焗蛋也已尝过，味道不错挺好吃的，咸淡适宜跟卤蛋还是有区别的，放在拌面或凉面里很不错的。现在足不出户就能买到各种东西种东西
          </h2>
          <span>8小时前</span>
        </div>
      </div>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  methods: {
    getImmigrationDetail() {
      this.$router.push("/news/ImmigrationDetail");
    },
  },
};
</script>

<style scoped lang="less">
.home {
  background: #f7f7f7;
  padding: 56px 0 70px;
  box-sizing: border-box;
}
@media (max-width: 576px) {
  .home {
    padding: 25px 15px;
    .content {
      .title {
        font-size: 18px;
        margin-bottom: 15px;
      }
      .box {
        padding: 10px;
        margin-bottom: 15px;
        .img {
          width: 112px;
          height: 93px;
          img {
            width: 112px;
            height: 93px;
            margin-right: 10px;
          }
        }
        .neirong {
          h1 {
            font-size: 15px;
            line-height: 21px;
            margin-bottom: 5px;
          }
          h2 {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
      .block {
        margin-top: 25px;
        .el-pagination {
          ::v-deep .el-pagination__sizes {
            display: none !important;
          }
          ::v-deep .el-pagination__jump {
            margin-left: 0;
          }
          ::v-deep .el-pager li {
            min-width: 25px !important;
          }
        }
      }
    }
  }
}
.title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 35px;
  color: #1c1d25;
  text-align: left;
  margin-bottom: 30px;
}
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
.box {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 39, 147, 0.08);
  border-radius: 16px 16px 16px 16px;
  padding: 25px;
  box-sizing: border-box;
  margin-bottom: 20px;
  .img {
    width: 158px;
    height: 131px;
    margin-right: 15px;
    img {
      width: 158px;
      height: 131px;
    }
  }
  .neirong {
    display: flex;
    flex-direction: column;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #0c1223;
      text-align: left;
      margin-bottom: 15px;
    }
    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: rgba(12, 18, 35, 0.5);
      line-height: 22px;
      text-align: left;
      /* 设置最多显示两行 */
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; // 设置为2表示最多显示两行
    }
    span {
      margin-top: auto;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: rgba(12, 18, 35, 0.5);
      line-height: 22px;
      text-align: left;
    }
  }
}
.box:last-child {
  margin-bottom: 30px;
}
.block {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  ::v-deep {
    .btn-prev,
    .btn-next,
    .el-pager li {
      background-color: transparent;
    }
  }
}
</style>
